import { type QueryClient, useQuery } from '@tanstack/react-query';
import { TeamsApi } from '@up2stay/up2promo-api-client';

export function userTeamMembershipQueryKey(workspaceId: string) {
  return ['user-team-membership', workspaceId] as const;
}

export function invalidateUserTeamMembershipQueries(
  queryClient: QueryClient,
  workspaceId: string,
): void {
  void queryClient.invalidateQueries({
    queryKey: userTeamMembershipQueryKey(workspaceId),
  });
  void queryClient.invalidateQueries({
    queryKey: ['workspace-team-status', workspaceId],
  });
}

/** Whether the signed-in user belongs to at least one team in this workspace. */
export function useUserTeamMembership(workspaceId: string | null | undefined): {
  hasTeamMembership: boolean;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery({
    queryKey: workspaceId
      ? userTeamMembershipQueryKey(workspaceId)
      : ['user-team-membership', 'none'],
    enabled: Boolean(workspaceId),
    queryFn: async () => {
      const res = await TeamsApi.findAll({
        path: { workspaceId: workspaceId as string },
        query: { page: 1, limit: 1, onlyMine: true },
      });
      return (res.data?.totalCount ?? res.data?.data?.length ?? 0) > 0;
    },
    staleTime: 15_000,
  });

  return {
    hasTeamMembership: Boolean(workspaceId) && Boolean(data),
    isLoading: Boolean(workspaceId) && isLoading,
  };
}
